import { useEffect, useState } from 'react';
import { getLocalStorageItem } from 'util/localStorage';

export const useLastLoadedTopicsCount = () => {
    const KEY = 'topicsCount';
    const [count, setCount] = useState(0);
    useEffect(() => {
        try {
            // TypeScript upgrade (v4.4.3). Please correct when you revisit this code.
            // eslint-disable-next-line no-shadow
            const count = getLocalStorageItem(KEY);
            if (count && !Number.isNaN(Number(count))) {
                setCount(Number(count));
            }
        } catch (e) {
            setCount(0);
        }
    }, []);
    return {
        count,
    };
};
